export enum BusinessEntityStatus {
Active,
UnderLiquidation,
Disabled,
Nothing,
}
